<template>
  <aside>
    <h3>{{ $t('advert.detail.metadata.participantsLimit') }}</h3>
    <p>{{ limit }}</p>
  </aside>
</template>

<script>
export default {
  name: 'ParticipantsLimit',
  props: {
    limit: {
      type: Number,
      required: false,
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "src/assets/style/advertMetaData";
</style>
